import { render } from "./Summary4doc.vue?vue&type=template&id=78694097&scoped=true"
import script from "./Summary4doc.vue?vue&type=script&lang=js"
export * from "./Summary4doc.vue?vue&type=script&lang=js"

import "./Summary4doc.vue?vue&type=style&index=0&id=78694097&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78694097"]])

export default __exports__